import React, { useCallback, useEffect, useState } from 'react'
import ListEmpleados from './ListEmpleados'
import { apiEmpleadosService } from 'services/apiEmpleadosService';
import { useAuth } from 'context/AuthProvider';
import { apiDepartamentosService } from 'services/apiDepartamentosService';
import { apiHorariosService } from 'services/apiHorariosService';
import { apiCentrosService } from 'services/apiCentrosService';
import { showAppAlert } from "components/common/AppAlerts";


const ListEmpleadosImpl = () => {
  const { empresa } = useAuth();
  const [content, setContent] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  const [departamentoId, setDepartamentoId] = useState(null);
  const [centroId, setCentroId] = useState(null);
  const [horarioId, setHorarioId] = useState(null);

  const [centros, setCentros] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [horarios, setHorarios] = useState([]);


  const [order, setOrder] = useState("asc")

  
  const hoy = new Date();


function formatoFecha(fecha, formato) {
    const map = {
        dd: fecha.getDate().toString().padStart(2, '0'), 
        mm: (fecha.getMonth() + 1).toString().padStart(2, '0'), 
        yyyy: fecha.getFullYear().toString()
    }

    return formato.replace(/dd|mm|yyyy/gi, matched => map[matched]);
}

const [fechaBaja, setFechaBaja] = useState(formatoFecha(hoy, "yyyy-mm-dd"));

  
  const fetchEmpleados = useCallback(async () => {
    
      
    try {
      
      const response = await apiEmpleadosService.getAllFiltered(
        empresa.id,
        centroId,
        departamentoId,
        horarioId,
        fechaBaja,
        order,
        currentPage,
        10
      );
      setContent(response.content);
      setTotalPage(response.totalPages);
    } catch (error) {
      showAppAlert(`Error al obtener los empleados: ${error?.message || "Error desconocido"}`, "error");
    }
  }, [empresa.id, centroId, departamentoId, horarioId, currentPage, fechaBaja, order]);

  const fetchFiltro = useCallback(async () => {
    try {
      const DepartamentosData = await apiDepartamentosService.getAll(empresa.id, 0, 1000);
      const HorariosData = await apiHorariosService.getAll(empresa.id, 0, 1000);
      const CentrosData = await apiCentrosService.getAllCentros(empresa.id, 0, 1000);

      setCentros(CentrosData.content);
      setDepartamentos(DepartamentosData.content);
      setHorarios(HorariosData.content);
    } catch (error) {
      console.error('Error al cargar los filtros:', error);
    }
  }, [empresa.id]);

  useEffect(() => {
    fetchFiltro();
    fetchEmpleados();
  }, [currentPage, centroId, departamentoId, horarioId, empresa, fetchEmpleados, fetchFiltro]);

  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleMostrarBaja = () =>{
    if(fechaBaja===''){
      setFechaBaja(formatoFecha(hoy, "yyyy-mm-dd"))
    }else(
      setFechaBaja('')
    )
  }

  return (
    <>
      <ListEmpleados
        empleados={content}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPage={totalPage}
        toggleModal={toggleModal}
        setEmpleados={setContent}
        horarios={horarios}
        setHorarioId={setHorarioId}
        departamentos={departamentos}
        setDepartamentoId={setDepartamentoId}
        centros={centros}
        setCentroId={setCentroId}
        handleMostrarBaja={handleMostrarBaja}
        order={order}
        setOrder={setOrder}
      />
    </>
  );
};

export default ListEmpleadosImpl;
